import { MerchantGatewayUserResponse } from 'deposit/services/types';

import { EDateFormats } from 'common/config/constants/date-formats';
import { formatDateTo } from 'common/helpers/date';

export interface MerchantGatewayUser {
  id: number;
  fullName: string;
  phone: string;
  notify: boolean;
  validateSameUser: boolean;
  address?: {
    zip?: string;
    firstLine?: string;
    secondLine?: string;
    city?: string;
    province?: string;
    country?: string;
  };
  email?: string;
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  documentNumber?: string;
  documentType?: string;
}

export const createMerchantUserAdapter = (merchantUser: MerchantGatewayUserResponse) => ({
  id: merchantUser.id,
  phone: merchantUser.phone,
  notify: merchantUser.notify,
  validateSameUser: merchantUser.validateSameUser,
  email: merchantUser.email,
  firstName: merchantUser.firstName,
  lastName: merchantUser.lastName,
  fullName: merchantUser.fullName,
  documentType: merchantUser.documentType?.toUpperCase(),
  documentNumber: merchantUser.document,
  birthDate: formatDateTo(merchantUser.birthDate, EDateFormats.dd_MM_yyyy),
  address: {
    firstLine: merchantUser.address?.line1,
    secondLine: merchantUser.address?.line2,
    city: merchantUser.address?.city,
    country: merchantUser.address?.country,
    province: merchantUser.address?.province,
    zip: merchantUser.address?.zip,
  },
});
